var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-card"},[_c('p',{staticClass:"heading mb-5"},[_vm._v(_vm._s(_vm.heading)+" Performance")]),_c('AreaLineChart',{attrs:{"rawData":_vm.performanceData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }